"use client";

import { useTheme } from "next-themes";
import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";

export function ModeToggle() {
  const { setTheme, resolvedTheme } = useTheme();
  const [isDarkMode, setIsDarkMode] = useState<boolean | null>(null);

  useEffect(() => {
    const isDarkMode = resolvedTheme
      ? resolvedTheme === "dark"
      : localStorage?.getItem("theme") === "dark";

    setIsDarkMode(isDarkMode);
  }, [resolvedTheme]);

  const toggleTheme = () => setTheme(isDarkMode ? "light" : "dark");

  if (isDarkMode === null) return null;
  return (
    <button
      className="w-12 h-6 rounded-full bg-neutral-800 border border-neutral-800 hover:border-neutral-600 flex items-center transition duration-300 focus:outline-none shadow"
      onClick={toggleTheme}
      aria-label="Toggle theme"
    >
      <div
        className={cn(
          "w-[22px] h-[22px] rounded-full transition-transform duration-300 bg-neutral-600 flex items-center justify-center",
          {
            "translate-x-6": isDarkMode,
            "-translate-x-0": !isDarkMode,
          }
        )}
      >
        {isDarkMode ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="w-4 h-4 text-white"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
            />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="w-4 h-4 text-white"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
            />
          </svg>
        )}
      </div>
    </button>
  );
}
